import { Outlet, createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/buyer-panel')({
  beforeLoad: requireRole('buyer_panel'),
  component: Outlet,
})
